/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                jQuery(document).ready(function($) {
                    $('label.job').click(function() {
                        $(this).addClass('selected');
                        $(this).find('input[type="radio"]').prop('checked', true);
                        $('label.job').not(this).removeClass('selected');
                        $('label.job').not(this).find('input[type="radio"]').prop('checked', false);

                        var target_form = $('#compila');

                        if( target_form.length ) {
                            event.preventDefault();
                            $('html, body').animate({
                                scrollTop: target_form.offset().top
                            }, 900);
                        }

                    });
                    $('a[href^="#"]').on('click', function(event) {
                        var target = $($(this).attr('href'));

                        if( target.length ) {
                            event.preventDefault();
                            $('html, body').animate({
                                scrollTop: target.offset().top
                            }, 900);
                        }
                    });

                    $.validator.addMethod("tel", function (value, element) {
                        return this.optional(element) || /^([+]39)?\s?((313)|(32[03789])|(33[013456789])|(34[0256789])|(36[0368])|(37[037])|(38[0389])|(39[0123]))[\s-]?([\d]{7})$/.test(value);
                    }, "Specificare un numero di telefono valido senza usare spazi.");



                    $("#form").validate({
                        lang: 'it',
                        rules: {
                            name: {
                                required:true
                            },
                            email: {
                                required:true,
                                email: true
                            },
                            phone: {
                                required: true,
                                tel: true
                            },
                            model:{
                                required: true
                            },
                            ref : {
                                required: true
                            },
                            price: {
                                required: true,
                                number: true
                            },
                            year:{
                                required: true,
                                digits: true,
                                maxlength: 4,
                                minlength: 4
                            },
                            privacy: {
                                required: true
                            },
                            image: {
                                required: true
                            }
                        }
                    });

                    /*$.cookieBar({
                        message: 'Utilizziamo i cookie per essere sicuri che tu possa avere la migliore esperienza sul nostro sito. Se continui ad utilizzare questo sito noi assumiamo che tu ne sia felice.',
                        acceptButton: true,
                        acceptText: 'Accetto',
                        fixed: true,
                        bottom: true,
                        zindex: 9999,
                    });*/

                    /* Add class on upload container when the input file content changes */

                    $('#cv').change(function() {
                        if($(this).val()) {
                            $(".file-area").addClass('selected');
                            $(this).addClass('valid').removeClass('error');
                            $('#cv-error').remove();
                        }
                    });
                });
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
